import { initializeApp } from 'firebase/app';
import { getAnalytics, Analytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getRemoteConfig } from 'firebase/remote-config';
import { DEFAULT_TRANSLATIONS } from '../i18n/defaults';

// Configuración del ambiente actual (Auth, Firestore, Remote Config)
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Configuración de producción (solo para Storage compartido)
const productionStorageConfig = {
  apiKey: process.env.REACT_APP_STORAGE_API_KEY || process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_STORAGE_AUTH_DOMAIN || process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_STORAGE_PROJECT_ID || process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET || process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
};

// App principal (Auth, Firestore, Remote Config)
const app = initializeApp(firebaseConfig);

// Analytics solo se inicializa si hay measurementId configurado (producción y staging)
let analytics: Analytics | null = null;
if (firebaseConfig.measurementId) {
  analytics = getAnalytics(app);
}

// App secundaria solo para Storage (siempre apunta a producción)
const isProduction = process.env.REACT_APP_ENV === 'production';
const storageApp = isProduction ? app : initializeApp(productionStorageConfig, 'storage');

// Inicializar servicios
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(storageApp);
const googleProvider = new GoogleAuthProvider();
const remoteConfig = getRemoteConfig(app);
remoteConfig.settings.minimumFetchIntervalMillis = 0;
remoteConfig.defaultConfig = {
  enable_charging: false,
  ...DEFAULT_TRANSLATIONS,
};

// Exportar
export { auth, db, storage, googleProvider, remoteConfig, analytics };